import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, DrawerBody, DrawerContent, } from '@awaze/design-system.components.drawer';
import { useDisclosure } from '@awaze/design-system.utils.react';
import { DesktopFormat, MobileFormat, useHandleFormatChange, } from '../search-form-composition/search-form-composition.styles';
import { useSearchFormContext } from '../search-form.context';
import { SearchSummaryBar } from './search-summary-bar';
export const SearchSummary = ({ onSearchFormSummaryClick, children, isFloating = true, }) => {
    const { initialValues, translations, resetToInitialValues, locale } = useSearchFormContext();
    const { isOpen, open, close: closeAction } = useDisclosure();
    useHandleFormatChange(closeAction);
    const { adult = 0, child = 0, infant = 0, ...rest } = initialValues;
    const guests = adult + child + infant;
    const close = () => {
        resetToInitialValues();
        closeAction();
    };
    const onClickSearchSummary = (callback) => {
        open();
        callback && callback();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MobileFormat, { "data-testid": "default-search-composition", children: [_jsx(SearchSummaryBar, { ...rest, guests: guests, onClick: () => onClickSearchSummary(onSearchFormSummaryClick), isFloating: isFloating, translations: translations.summaryStrings, locale: locale }), _jsx(Drawer, { isOpen: isOpen, placement: "right", close: close, children: _jsx(DrawerContent, { header: translations.destination.searchFormTitle, children: _jsx(DrawerBody, { children: children }) }) })] }), _jsx(DesktopFormat, { children: children })] }));
};
//# sourceMappingURL=search-summary.js.map